export interface UserCardHeaderProps {
	userId?: string | null;

	name?: string | null;

	role?: string | null;

	avatarUrl?: string | null;

	timestamp?: string;
}

import { useAvatar } from "src/hooks";

const UserCardHeader = ({
	userId,
	name,
	role,
	timestamp
}: UserCardHeaderProps) => {
	const { data: imageUri } = useAvatar({
		userId,
		enabled: Boolean(userId)
	});

	const isSponsored = role === "Sponsored Post";

	const initials = name
		? name
				.split(" ")
				.slice(0, 2)
				.map((n) => n[0])
				.join("")
				.toUpperCase()
		: "";

	return (
		<div className="px-4 py-3">
			<div className="flex items-center gap-3">
				{!isSponsored && (
					<div className="relative w-9 h-9 shrink-0">
						{imageUri ? (
							<img
								src={imageUri}
								alt={name ?? ""}
								className="w-9 h-9 rounded-full object-cover"
							/>
						) : (
							<div
								role="img"
								aria-label={name ?? ""}
								className="w-9 h-9 rounded-full bg-zinc-200 text-zinc-600 flex items-center justify-center text-xs font-medium"
							>
								{initials}
							</div>
						)}
					</div>
				)}

				<div className="min-w-0 flex-1">
					<p className="text-sm font-medium text-foreground truncate">
						{name ?? "Unknown user"}
					</p>
					{role && <p className="text-[13px] text-muted-foreground">{role}</p>}
				</div>

				{timestamp && (
					<p className="text-[13px] text-muted-foreground shrink-0">
						{timestamp}
					</p>
				)}
			</div>
		</div>
	);
};

export default UserCardHeader;
